import type { CoinBalanceEntry } from './models';
import type { CoinBalanceDto } from './types';

function toFiniteNumber(value: string | number | undefined): number {
  if (value === undefined || value === null) return 0;
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return Number.isFinite(num) ? num : 0;
}

export function mapCoinBalance(dto: CoinBalanceDto): CoinBalanceEntry {
  return {
    coinId: dto.i,
    balance: toFiniteNumber(dto.b),
    frozen: toFiniteNumber(dto.f),
  };
}

export function mapCoinBalanceList(dtos: CoinBalanceDto[]): CoinBalanceEntry[] {
  return dtos.map(mapCoinBalance);
}
